import { initSentryReact } from '@/sentry-react';
initSentryReact();

import React from 'react';
import ReactDOM from 'react-dom/client';
import SentryErrorBoundary from '@/components/SentryErrorBoundary';
import App from './App';

interface OwnerContext {
  username: string;
  displayName: string;
  avatarUrl: string;
}

declare global {
  interface Window {
    __OWNER_CONTEXT__?: OwnerContext;
  }
}

const context = window.__OWNER_CONTEXT__;
if (!context) {
  throw new Error('Missing __OWNER_CONTEXT__ on window');
}

const root = document.getElementById('owner-calendar-root');
if (!root) {
  throw new Error('Missing #owner-calendar-root element');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <App owner={context} />
    </SentryErrorBoundary>
  </React.StrictMode>
);
